var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6635 6.79403L17.2607 9.39118M12.9321 18.9141H19.8578M6.00634 15.4512L5.14062 18.9141L8.60349 18.0483L18.6337 8.01815C18.9583 7.69346 19.1406 7.25314 19.1406 6.79403C19.1406 6.33492 18.9583 5.8946 18.6337 5.56991L18.4848 5.421C18.1601 5.09641 17.7198 4.91406 17.2607 4.91406C16.8015 4.91406 16.3612 5.09641 16.0365 5.421L6.00634 15.4512Z",
    stroke: "#333333",
    strokeWidth: 1.29857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.5b49af8c97c951fb0541d495edeaf17c.svg";
export { ForwardRef as ReactComponent };